import {useContext, useEffect} from "react";
import {API, Auth} from "aws-amplify";
import {toast} from "react-toastify";
import {Context} from "../../../Context";
import {useNavigate} from "react-router-dom";

const Redirect = () => {
  const { setLoader, setUserData, institutionData,setAuth } = useContext(Context);
  const { InstitutionId } = institutionData;
  const navigate = useNavigate();

  useEffect(() => {
    const redirect = async () => {
      setLoader(true);
      try {
        await Auth.currentAuthenticatedUser();

        const userdata = await API.get(
          'main',
          `/user/get-userdata/${InstitutionId}`,
          {}
        );
        setUserData(userdata);
        setAuth(true);
        toast.info('Logged in');
        setLoader(false);
        const path = window.sessionStorage.getItem('login_redirect');
        window.sessionStorage.removeItem('login_redirect');
        
        navigate('/dashboard/profile',{ replace: true });
      } catch (e) {
        toast.error('Please signup first');
        setLoader(false);
        navigate('/signup');
      }
    }

    redirect();
  }, []);
}

export default Redirect;